module.exports = __webpack_public_path__ + "img/logo_portrait_dark.9f451aa1.svg";